export default __webpack_public_path__ + "static/media/sslb1.d2248f3e.PNG";